import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {ToasterConfig} from 'angular2-toaster/angular2-toaster';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['../scss/vendors/toastr/toastr.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
    toasterconfig: ToasterConfig =
        new ToasterConfig({
            tapToDismiss: true,
            timeout: 5000,
            toastContainerId: 1
        });

    constructor(private router: Router) {
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }

}
